<button type="button" [style.width]="data?.width" [style.marginTop]="data?.marginTop" [style.marginBottom]="data?.marginBottom"
  [style.marginLeft]="data?.marginleft" [style.marginRight]="data?.marginRight" [style.height]="data?.height"
  [style.fontSize]="data?.fontSize" [style.fontWeight]="data?.fontWeight" [ngClass]="getButtonClasses()"
  [disabled]="isUploading || isSubmitting" (click)="onClick(data.key)">
  {{ getButtonLabel() }}
</button>

<input
  #uploadInput
  type="file"
  [accept]="data?.accept || '*/*'"
  hidden
  (change)="onFileSelected($event)"
/>
